import { Provider } from '@angular/core';
import { PureAbility } from '@casl/ability';

import { AppAbility } from './core/auth/states/auth-profile.state';

export function provideCasl(): Provider[] {
  return [
    { provide: AppAbility, useValue: AppAbility },
    { provide: PureAbility, useExisting: AppAbility },
  ];
}
